import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Loading = ({ label = "Chargement…" }) => (
  <div className="grid min-h-[50vh] place-items-center text-slate-500" data-testid="loading-state">
    <div className="flex flex-col items-center gap-2">
      <Loader2 className="h-6 w-6 animate-spin text-brand" />
      <p className="text-sm">{label}</p>
    </div>
  </div>
);

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loading label="Vérification de votre session…" />;
  if (!user) return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role))
    return (
      <div className="mx-auto max-w-lg px-4 py-20 text-center" data-testid="access-denied">
        <h1 className="font-display text-2xl font-bold text-slate-900">Accès refusé</h1>
        <p className="mt-2 text-sm text-slate-600">
          Votre rôle ({user.role}) ne permet pas d'accéder à cette section.
        </p>
      </div>
    );
  return children;
};
